@if (requiresValue) {
  <ce-form-field>
    <mat-select
      placeholder="Select..."
      ceInput
      [value]="internalValue"
      (openedChange)="handleOpenChange($event)"
      (selectionChange)="onSelectionChange($event)"
      [multiple]="multiselect">
      @for (option of options; track option.value) {
        <mat-option [value]="option.value">{{ option.label }}</mat-option>
      }
    </mat-select>
  </ce-form-field>
}
